<template>
    <div>
      <v-container class="grey lighten-5 mb-5">
        <v-card dense :loading="loading" elevation="24">
            <v-card-title class="mb-0">
              <Link :href="baseurl+'/job/'+job.alias" class="text-lg-h5 text-md-h6 text-sm-h6">{{job.title}}</Link>
                
                <v-icon color="blue" class="ml-5" large v-if="job.isFeatured">mdi-seal</v-icon>

                <template v-if="canApply()"> 
                  <v-spacer></v-spacer>
                  <v-icon v-if="!job.isFavorite" @click="triggerAddFavorite()" class="m-5" color="primary">mdi-heart-outline</v-icon>
                  <v-icon v-if="job.isFavorite" @click="triggerDelFavorite()" class="m-5" color="primary">mdi-heart</v-icon>
                </template>
            </v-card-title>
            <v-card-subtitle class="border-bottom-purple mb-3 mr-3 ml-3">
                <v-btn outlined color="primary" class="mr-2" v-if="job.organization.is_returner_friendly"><v-icon color="primary">mdi-home-export-outline</v-icon>Returner Friendly</v-btn>
                
                <v-btn outlined color="green" class="mr-2"  v-if="job.minimum_salary && job.maximum_salary"><v-icon color="green">mdi-currency-eur</v-icon>{{ job.minimum_salary }}-{{ job.maximum_salary }}</v-btn>
                <v-btn outlined color="green" class="mr-2" v-else-if="job.minimum_salary"><v-icon color="green">mdi-currency-eur</v-icon>{{ job.minimum_salary }}</v-btn>
                <v-btn outlined color="green" class="mr-2" v-else-if="job.maximum_salary"><v-icon color="green">mdi-currency-eur</v-icon>{{ job.maximum_salary }}</v-btn>
                <v-btn outlined color="blue" class="mr-2" v-if="job.remote_type && job.remote_type == 'Remote'"><v-icon>mdi-home</v-icon>{{ job.remote_type }}</v-btn>
                <v-btn outlined color="blue" class="mr-2" v-if="job.remote_type && job.remote_type == 'Hybrid'"><v-icon>mdi-home-city</v-icon>{{ job.remote_type }}</v-btn>
                <v-btn outlined color="blue" class="mr-2" v-if="job.remote_type && job.remote_type == 'In-person'"><v-icon>mdi-office-building</v-icon>{{ job.remote_type }}</v-btn>
                <v-btn outlined color="orange" class="mr-2" v-if="job.career_level"><v-icon color="orange">mdi-briefcase</v-icon>{{ job.career_level }}</v-btn>
                <v-btn outlined color="teal" class="mr-2" v-if="job.contract_type"><v-icon color="teal">mdi-file-sign</v-icon>{{ job.contract_type }}</v-btn>
            </v-card-subtitle>
            <v-card-text class="hidden-md-and-down mb-0 pb-0">
              <div class=""
                style="float:left;height:100px;width:100px;"  v-if="job.organization.photo_path">
                <v-container fill-height fluid style="margin:0;padding:0">
                  <v-row align="center"
                      justify="center"
                      style="margin:0;padding:0">
                      <v-col style="margin:0;padding:0">
                        <v-img 
                          contain
                          max-height="100"
                          max-width="100"
                          style="margin:0;padding:0"
                          :src="baseurl + '/img/'+job.organization.photo_path">
                        </v-img>
                      </v-col>
                  </v-row>
                </v-container>
                
              </div>
              
                    
               
              <v-container class="mb-0 pb-0">
                  <v-row>
                    <v-col cols="12" md="12">
                      <a :href="baseurl+'/organization/'+job.organization.alias" style="color:rgba(0,0,0,0.6) !important"><span class=" text-lg-h5 text-md-h6 text-body-1 ml-5">{{job.organization.name}} <v-icon>mdi-open-in-new</v-icon></span></a>
                      <template v-if="job.stop_publishing">
                        <br/>
                        <span class="dark-grey--text ml-5">Closing: {{ job.stop_publishing }}</span>
                        
                        <span class="dark-grey--text ml-5" v-if="job.region">Region: {{ job.region }}</span>
                      </template>
                    </v-col>
                  </v-row>
                   <v-row v-if="job.description" class="hidden-md-and-down mb-0">
                      <v-col cols="12" md="12" class="pb-0">
                          <p v-html="job.description"></p>
                      </v-col>
                  </v-row>
                  <v-row v-if="0">
                    <v-col cols="12" sm="12" lg="4" md="6" v-if="job.minimum_salary || job.maximum_salary || job.salary_type">
                      <span class="text-lg-h6 text-md-body-1">Salary <v-icon>mdi-cash</v-icon></span>
                          <p>
                              <span v-if="job.minimum_salary && job.maximum_salary">€{{ job.minimum_salary }} - {{ job.maximum_salary }}</span>
                              <span v-else-if="job.minimum_salary">€{{ job.minimum_salary }}</span>
                              <span v-else-if="job.maximum_salary">€{{ job.maximum_salary }}</span>
                              <span v-else>Not disclosed</span>
                              <span v-if="job.salary_type"> {{job.salary_type }}</span>
                          </p>
                    </v-col>
                    <v-col cols="12" sm="12" lg="4" md="6" v-if="job.minimum_experience || job.maximum_experience">
                        <span class="text-lg-h6 text-md-body-1">Experience <v-icon>mdi-account-hard-hat</v-icon></span>
                        <p>
                            <span v-if="job.minimum_experience && job.maximum_experience">{{ job.minimum_experience }} - {{ job.maximum_experience }} years</span>
                            <span v-else-if="job.minimum_experience">{{ job.minimum_experience }} year(s)</span>
                            <span v-else-if="job.maximum_experience">{{ job.maximum_experience }} year(s)</span>
                        </p>
                    </v-col>
                    <v-col cols="12" sm="12" lg="4" md="6" v-if="job.region">
                        <span class="text-lg-h6 text-md-body-1">Location <a :href="getUrl()" target="_blank"><v-icon>mdi-map</v-icon></a></span>
                        <p>{{job.region}}&nbsp;<a :href="getUrl()" target="_blank"><v-icon>mdi-open-in-new</v-icon></a></p>
                    </v-col>
                  </v-row>
                  
                  
              </v-container>
            </v-card-text>
            <v-card-text class="hidden-lg-and-up">
             <div>

              <div class=""
                style="float:left;height:100px;width:100px;"  v-if="job.organization.photo_path">
                <v-container fill-height fluid style="margin:0;padding:0">
                  <v-row align="center"
                      justify="center"
                      style="margin:0;padding:0">
                      <v-col style="margin:0;padding:0">
                        <v-img 
                          contain
                          max-height="100"
                          max-width="100"
                          style="margin:0;padding:0"
                          :src="baseurl + '/img/'+job.organization.photo_path">
                        </v-img>
                      </v-col>
                  </v-row>
                </v-container>
                
              </div>
              <a :href="baseurl+'/organization/'+job.organization.alias" style="color:rgba(0,0,0,0.6) !important" target="_blank"><span class=" text-lg-h5 text-md-h6 text-body-1 ml-5">{{job.organization.name}} <v-icon>mdi-open-in-new</v-icon></span></a>
                    
            </div>
              <v-container>
                  <v-row v-if="job.mobile_description" class="hidden-lg-and-up">
                      <v-col cols="12"  md="12">
                          <p v-html="job.mobile_description"></p>
                      </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" lg="4" md="12" v-if="job.minimum_salary || job.maximum_salary || job.salary_type">
                      <span class="text-lg-h6 text-md-body-1">Salary <v-icon>mdi-cash</v-icon></span>
                          <p>
                              <span v-if="job.minimum_salary && job.maximum_salary">€{{ job.minimum_salary }} - {{ job.maximum_salary }}</span>
                              <span v-else-if="job.minimum_salary">€{{ job.minimum_salary }}</span>
                              <span v-else-if="job.maximum_salary">€{{ job.maximum_salary }}</span>
                              <span v-else>Not disclosed</span>
                              <span v-if="job.salary_type"> {{job.salary_type }}</span>
                          </p>
                    </v-col>
                    <v-col cols="12" sm="12" lg="4" md="12" v-if="job.minimum_experience || job.maximum_experience">
                        <span class="text-lg-h6 text-md-body-1">Experience <v-icon>mdi-account-hard-hat</v-icon></span>
                        <p>
                            <span v-if="job.minimum_experience && job.maximum_experience">{{ job.minimum_experience }} - {{ job.maximum_experience }} years</span>
                            <span v-else-if="job.minimum_experience">{{ job.minimum_experience }} year(s)</span>
                            <span v-else-if="job.maximum_experience">{{ job.maximum_experience }} year(s)</span>
                        </p>
                    </v-col>
                    <v-col cols="12" sm="12" lg="4" md="12" v-if="job.region">
                        <span class="text-lg-h6 text-md-body-1">Location <a :href="getUrl()" target="_blank"><v-icon>mdi-map</v-icon></a></span>
                        <p><span v-if="job.address">{{ job.address }}</span>&nbsp;<span v-if="job.city">{{ job.city }}</span>&nbsp;<span v-if="job.postal_code">{{ job.postal_code }}</span>&nbsp;{{job.region}}&nbsp;<a :href="getUrl()" target="_blank"><v-icon>mdi-open-in-new</v-icon></a></p>
                    </v-col>
                  </v-row>
                  
                  
              </v-container>
            </v-card-text>
            <v-card-actions class="justify-center mt-0 pt-0 hidden-md-and-down">
                <v-row>
                  <v-col cols="12" lg="4" class=" pl-5" v-if="job.course_orgs && job.course_orgs.length">
                    <span class="overline">Need to upskill or retrain?</span><br/>
                    <v-tooltip bottom v-for="o in job.course_orgs" :key="o.course_id" >
                      <template v-slot:activator="{ on, attrs }">
                        <Link :href="baseurl+'/course/'+o.course_alias" style="display:inline-block" v-bind="attrs"
          v-on="on">
                          <v-img 
                            :src="baseurl + '/img/'+o.org_photo_path" max-height="45" max-width="60" contain>
                          </v-img>
                        </Link> 
                      </template>
                      <span v-if="o.course_title">{{ o.course_title }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12" lg="8" class="text-right pr-5">
                    <br/>
                    <Link :href="baseurl+'/job/'+job.alias">
                      <v-btn color="primary"><v-icon style="margin-right:3px">mdi-eye</v-icon>Details</v-btn>
                    </Link>
                    <template v-if="canApply()">
                      <v-btn v-if="!job.isApplied" @click="triggerApply()" color="primary" class="ml-5"><v-icon style="margin-right:3px">mdi-send</v-icon>Apply</v-btn>
                      <v-btn v-if="job.isApplied" color="secondary" class="ml-5"><v-icon style="margin-right:3px">mdi-check</v-icon>Applied</v-btn>
                      </template>
                  </v-col>
                </v-row>
                
               </v-card-actions>

               <v-card-actions class="justify-center mt-0 pt-0 hidden-lg-and-up">
                <div class="container">
                  <v-row>
                    <v-col cols="12" lg="12" class=" pl-5" v-if="job.course_orgs && job.course_orgs.length">
                      <span class="overline">Need to upskill or retrain?</span><br/>
                      <v-tooltip bottom v-for="o in job.course_orgs" :key="o.course_id" >
                        <template v-slot:activator="{ on, attrs }">
                          <Link :href="baseurl+'/course/'+o.course_alias" style="display:inline-block" v-bind="attrs"
            v-on="on">
                            <v-img 
                              :src="baseurl + '/img/'+o.org_photo_path" max-height="45" max-width="60" contain>
                            </v-img>
                          </Link> 
                        </template>
                        <span v-if="o.course_title">{{ o.course_title }}</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" lg="12" class="text-center">
                      <Link :href="baseurl+'/job/'+job.alias">
                        <v-btn color="primary"><v-icon style="margin-right:3px">mdi-eye</v-icon>Details</v-btn>
                      </Link>
                      <template v-if="canApply()">
                        <v-btn v-if="!job.isApplied" @click="triggerApply()" color="primary" class="ml-5"><v-icon style="margin-right:3px">mdi-send</v-icon>Apply</v-btn>
                        <v-btn v-if="job.isApplied" color="secondary" class="ml-5"><v-icon style="margin-right:3px">mdi-check</v-icon>Applied</v-btn>
                        </template>
                    </v-col>
                  </v-row>
                </div>
               </v-card-actions>

        </v-card>   
      </v-container>
      <JobApplyDialog 
        v-if="auth.user && !job.isApplied" 
        :user = "auth.user" 
        :dialog="applyDialog" 
        :job="job" 
        @close="applyDialog = false" 
        :baseurl="baseurl">
        </JobApplyDialog>

    </div>
</template>
<script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
  import JobApplyDialog from '@/Shared/JobApplyDialog'
  import axios from 'axios'
  
import { Link } from '@inertiajs/inertia-vue'

  export default {
    props: {
      job: Object,
      auth: Object,
      state: String,
      baseurl: String,
      prevurl: String,
    },
    components: {
      Head,
      JobApplyDialog,
      Link
    },
    layout: Layout,
    data() {
        return {
            applyDialog: false,
            loading: false,
        }
    },
    watch: {
    },
    created() {
    },
    methods: {
        
      canApply() {
        return true;
        if (!this.auth.user || (this.auth.user.roles.includes('admin') || this.auth.user.roles.includes('user')))
            return true;
        else
            return false;
      },
      getUrl() {
          return 'https://www.google.com/maps/search/?api=1&query='+encodeURIComponent(this.job.address +','+this.job.region)

      },
      isValidHttpUrl(string) {
        let url;
        
        try {
          url = new URL(string);
          console.log('send to url',url)
          return true;
        } catch (_) {
          return false;  
        }

        //return url.protocol === "http:" || url.protocol === "https:";
      },
      triggerApply() {
        console.log('trigger apply',this.job);

        if (this.job.require_login)
        {
          if (!this.auth.user)
            this.$emit('toggleComponentLogin','jobapply-'+this.job.id)
          else if (this.isValidHttpUrl(this.job.job_link))
            window.open(this.baseurl+'/job/'+this.job.alias+'/apply');
          else
            window.open("mailto:"+this.job.job_link)
        }
        else
        {
          if (this.isValidHttpUrl(this.job.job_link))
            window.open(this.baseurl+'/job/'+this.job.alias+'/apply');
          else
            window.open("mailto:"+this.job.job_link)
        }
        /*
        if (!this.auth.user)
            this.$emit('toggleComponentLogin','jobapply-'+this.job.id);
        else if (this.job.job_link)*/
       //  window.open(this.baseurl+'/job/'+this.job.alias+'/apply'); //window.open(window.location + '/apply')
        /*else
            this.applyDialog = true;*/
            
      },
      triggerAddFavorite() {
        this.loading=true;
        console.log('trigger addfavorite');
        let vm = this;
        if (!this.auth.user)
            this.$emit('toggleComponentLogin','jobaddfavorite-'+this.job.id);
        else
            this.$inertia.get(this.baseurl+"/user/job/addfavorite/"+this.job.id,{},{
              preserveState: true,
              preserveScroll: true,
              onFinish: visit => {
                // This won't be called until doThing()
                // and doAnotherThing() have finished.
                vm.loading = false;
              },
            })
      },
      triggerDelFavorite() {
        this.loading = true;
        let vm = this;
        console.log('trigger delfavorite',this.auth.user,this.baseurl+"/user/job/delfavorite/"+this.job.id);
        if (!this.auth.user)
          this.$emit('toggleComponentLogin','jobdelfavorite-'+this.job.id);
        else
            this.$inertia.get(this.baseurl+"/user/job/delfavorite/"+this.job.id,{},{
              preserveState: true,
              preserveScroll: true,
              onFinish: visit => {
                vm.$emit('refresh');
                // This won't be called until doThing()
                // and doAnotherThing() have finished.
                vm.loading = false;
              },
            });
      }
    },
  }
  </script>
  
  <style>
    .fixedFooter {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    color: white;
    text-align: center;
    }
    </style>